import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ProjectConsultantReducer } from '../reducers';

export const selectProjectConsultantFeature = createFeatureSelector<ProjectConsultantReducer.ProjectConsultantState>(ProjectConsultantReducer.featureName);

export const selectProjectConsultant = createSelector(selectProjectConsultantFeature, (state: ProjectConsultantReducer.ProjectConsultantState) => state.item);
export const selectTeamLeader = createSelector(selectProjectConsultantFeature, (state: ProjectConsultantReducer.ProjectConsultantState) => state.leader);
export const selectCountMember = createSelector(selectProjectConsultantFeature, (state: ProjectConsultantReducer.ProjectConsultantState) => state.countMember);
